import Image from "next/image";
import Link from "next/link";
import { ArrowRightCircle } from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";

type VariantStyle = {
  section: string;
  cercle: string;
  button: string;
};

const variantStyles: { [key: string]: VariantStyle } = {
  bleu: {
    section: "bg-white",
    cercle: "bg-blue",
    button: "bg-yellow",
  },
  orange: {
    section: "bg-violet-light",
    cercle: "bg-orange",
    button: "bg-orange",
  },
};

function getVariantStyle(variante?: string) {
  const key = variante?.toLowerCase?.().trim() || "bleu";
  return variantStyles[key] || variantStyles.bleu;
}

export default function NosOffres({ data }: BlockProps) {
  if (!data) return null;

  const offres = data?.offres || [];

  return (
    <section key={data.id}>
      {offres.map((item: any, index: number) => {
        const reverse = index % 2 === 1;
        const style = getVariantStyle(item.variante);

        const imageUrl = item?.image?.url;

        return (
          <article key={item.id} className={`${style.section} pt-10`}>
            <div className="mx-auto grid max-w-[1600px] items-center gap-5 px-6 md:px-10 lg:grid-cols-2 lg:gap-20 lg:px-16">
              {/* Texte */}
              <div className={reverse ? "lg:order-2" : "lg:order-1"}>
                <h4 className="font-literata max-w-[720px] text-[30px] lg:text-[38px] font-bold leading-[1.2] text-black md:text-[56px]">
                  {item.titre}
                </h4>

                <p className="lg:mt-8 mt-4 max-w-[720px] text-[18px] leading-[1.35] text-black md:text-[30px]">
                  {item.description}
                </p>

                {item.cta?.text && (
                  <div className="lg:mt-8 mt-4">
                    <Link
                      href={`${process.env.NEXT_PUBLIC_STRAPI_COMMANDE_ENDPOINT}`}
                      className={`inline-flex items-center gap-3 rounded-full px-7 py-4 text-[16px] font-semibold text-black transition  md:text-[22px] ${style.button}`}
                    >
                      {item.cta.text}
                      <ArrowRightCircle className="h-5 w-5 md:h-6 md:w-6" />
                    </Link>
                  </div>
                )}
              </div>

              {/* Image */}
              <div
                className={`relative flex items-center justify-center ${reverse ? "lg:order-1" : "lg:order-2"
                  }`}
              >
                <div className="relative flex h-[340px] w-[340px] items-center justify-center md:h-[470px] md:w-[470px]">
                  {/* cercle décoratif */}
                  <div
                    className={`absolute left-[-20px] top-[18px] h-[150px] w-[150px] rounded-full md:left-[-28px] md:top-[22px] md:h-[190px] md:w-[190px] ${style.cercle}`}
                  />

                  {/* image */}
                  {item?.image?.url && (
                    <div className="relative z-10 flex h-full w-full items-center justify-center">
                      <Image
                        src={imageUrl}
                        alt={item.titre}
                        width={420}
                        height={520}
                        className="max-h-full w-auto object-contain"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}